/* eslint-disable  */
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { productActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import ReactPaginate from "react-paginate";
import { debounce } from "lodash";
import Modal from "../../AdminModel/Components/Modal";
import {
  FiSearch,
  FiXCircle,
  FiCalendar,
  FiMessageSquare,
  FiEye,
  FiRotateCcw,
} from "react-icons/fi";

function RejectedOrders() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetRejectedOrders, ResetProductResponse, ReverseOrderByMartOfficer } =
    bindActionCreators(productActionCreators, dispatch);

  const product = useSelector((state) => state.product);
  const { isLoading, orders, response, paginate } = product;

  const [limit, setLimit] = useState(15);
  const [pageCount, setPageCount] = useState(0);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [orderMessage, setOrderMessage] = useState("");
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetRejectedOrders(true, 1, limit, null);
  }, []);

  const handleReverseApplication = () => {
    ReverseOrderByMartOfficer(orderId);
    setOpenMessageModal(false);
  };

  useEffect(() => {
    GetRejectedOrders(true, 1, limit, null);
  }, [limit]);

  const handlePageClick = (event) => {
    GetRejectedOrders(true, event.selected + 1, limit, null);
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    GetRejectedOrders(true, 1, limit, val ? `&search=${val}` : null);
  }, 800);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetProductResponse();
        GetRejectedOrders(true, 1, limit, null);
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div className="min-h-screen bg-gray-50/30">
      <RenderHirePurchasePage>
        {isLoading && <Loader />}

        {/* --- Header --- */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
            <FiXCircle className="text-red-500" /> Rejected Orders
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Review declined applications and manage reversals
          </p>
        </div>

        {/* --- Filters --- */}
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col md:flex-row gap-4">
          <div className="relative flex-grow">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="search"
              placeholder="Search staff ID or name..."
              className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 outline-none transition-all text-sm"
              onChange={onSearchTextChange}
            />
          </div>

          <div className="flex items-center gap-3 bg-gray-50 px-3 py-1 rounded-lg border border-gray-200">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">
              Show:
            </label>
            <select
              className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
              onChange={(e) => setLimit(e.target.value)}
              value={limit}
            >
              {[15, 25, 50, 100].map((num) => (
                <option key={num} value={num}>
                  {num} Rows
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* --- Table --- */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-100">
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Member
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Affordability
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Date
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Facility
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Reason
                  </th>
                  <th className="px-6 py-4 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {orders?.map((order, index) => (
                  <tr
                    key={index}
                    className="hover:bg-red-50/30 transition-colors"
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <img
                          className="w-10 h-10 rounded-full object-cover grayscale"
                          src={order?.user_id?.profile_image}
                          alt=""
                        />
                        <div>
                          <p className="text-sm font-bold text-gray-900">
                            {order?.user_id?.name}
                          </p>
                          <p className="text-xs font-bold text-red-400">
                            {order?.user_id?.staff_id}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200">
                        {order?.affordability}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <FiCalendar className="text-gray-400" />
                        {moment(order?.created_at).format("MMM Do YY")}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {order?.facility}
                    </td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => {
                          setOrderMessage(order?.rejected[0]?.message);
                          setOrderId(order?._id);
                          setOpenMessageModal(true);
                        }}
                        className="flex items-center gap-1.5 text-xs font-bold text-red-600 dark:bg-slate-800 px-3 py-1.5 rounded-full hover:bg-red-200 transition-all"
                      >
                        <FiMessageSquare size={14} /> VIEW REASON
                      </button>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <button
                        onClick={() =>
                          history.push({
                            pathname: "/mart/order-detailed",
                            state: order,
                          })
                        }
                        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
                      >
                        <FiEye size={18} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          {orders?.length > 0 && (
            <div className="p-6 border-t border-gray-100 flex justify-center bg-gray-50">
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                previousLabel="<"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(pageCount / limit)}
                containerClassName="flex items-center gap-2"
                pageLinkClassName="px-4 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium hover:text-red-600 transition-all"
                activeLinkClassName="!bg-red-600 !text-white !border-red-600 shadow-md"
                previousLinkClassName="px-4 py-2 rounded-lg bg-white border border-gray-200"
                nextLinkClassName="px-4 py-2 rounded-lg bg-white border border-gray-200"
              />
            </div>
          )}
        </div>

        {/* --- Reason Modal --- */}
        {openMessageModal && (
          <Modal
            width={"400px"}
            title={"Rejection Details"}
            closeModal={setOpenMessageModal}
          >
            <div className="p-6">
              <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
                <p className="text-sm text-red-700 italic">
                  {orderMessage ||
                    "No message was attached. Please contact the Mart Head for clarification."}
                </p>
              </div>

              <div className="flex flex-col gap-3">
                <button
                  type="button"
                  onClick={() => handleReverseApplication()}
                  className="w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl transition-all shadow-lg shadow-green-100"
                >
                  <FiRotateCcw /> Reverse Application
                </button>
                <button
                  type="button"
                  onClick={() => setOpenMessageModal(false)}
                  className="w-full py-3 text-sm font-bold text-gray-500 hover:text-gray-700 transition-all"
                >
                  Close
                </button>
              </div>
            </div>
          </Modal>
        )}

        <ToastContainer autoClose={3000} position="bottom-right" />
      </RenderHirePurchasePage>
    </div>
  );
}

export default RejectedOrders;
